<!-- <button nz-button nzType="primary" class="ai-assist-btn" (click)="isOpen = !isOpen">
  <span nz-icon nzType="star"></span> DCR AI Assist
</button> -->

<div nz-row class="query-main-content" [nzGutter]="[16, 4]">
  <div nz-col class="left-content" nzSpan="6">
    <nz-card>
      <form nz-form nzLayout="vertical">
        <!-- Datasource -->
        <nz-form-item>
          <nz-form-label class="nfl-form-label">Data Source</nz-form-label>
          <nz-form-control nzErrorTip="Please select the data source.">
            <nz-select
              nzPlaceHolder="Select Data Source"
              nzSize="large"
              [nzMaxTagCount]="3"
              [nzMaxTagPlaceholder]="datasourcePlaceholder"
              nzMode="multiple"
              [formControl]="selectedDatasources"
            >
              <nz-option
                [nzLabel]="datasource"
                [nzValue]="datasource"
                *ngFor="let datasource of dataSourceList; index as i"
              ></nz-option>
            </nz-select>
            <ng-template #datasourcePlaceholder let-selectedList
              >and {{ selectedList.length }} more selected</ng-template
            >
          </nz-form-control>
        </nz-form-item>
        <!-- Database -->
        <nz-form-item>
          <nz-form-label class="nfl-form-label">Database</nz-form-label>
          <nz-form-control nzErrorTip="Please select the database.">
            <nz-select
              nzPlaceHolder="Select Database"
              nzSize="large"
              [nzMaxTagCount]="3"
              [nzMaxTagPlaceholder]="databasePlaceholder"
              nzMode="multiple"
              [formControl]="selectedDatabases"
              [nzNotFoundContent]="noDatabaseTemplate"
            >
              <nz-option
                *ngFor="let database of databaseList; index as i"
                [nzLabel]="database"
                [nzValue]="database"
              ></nz-option>
            </nz-select>
            <ng-template #databasePlaceholder let-selectedList>and {{ selectedList.length }} more selected</ng-template>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label class="nfl-form-label">Tables And Schema(s)</nz-form-label>
          <div class="db-table-section">
            <nz-collapse nzAccordion nzSize="large">
              <nz-collapse-panel *ngFor="let table of tableList; index as i" [nzHeader]="showTableHeader">
                <div class="table-columns" *ngFor="let item of table.columns; index as j">
                  <span nz-typography nzEllipsis [nz-tooltip]="item.name">
                    {{ item.name }}
                    <nz-tag nzColor="blue" *ngIf="showIdentifierTag(item.identifier!)">{{ item.identifier }}</nz-tag>
                  </span>
                  <span> {{ item.type }} </span>
                </div>
                <ng-template #showTableHeader>
                  <div class="table-header">
                    <span class="title-text" [title]="table.tableName">{{ table.tableName }}</span>
                    <br />
                    <nz-tag nzColor="success">{{ table.datasourceName }}</nz-tag
                    >&nbsp;
                    <nz-tag nzColor="warning">{{ table.databaseName }}</nz-tag>
                  </div>
                </ng-template>
              </nz-collapse-panel>
            </nz-collapse>
          </div>
        </nz-form-item>
      </form>
    </nz-card>
  </div>
  <div nz-col class="right-content" nzSpan="18">
    <nz-card>
      <form nz-form [formGroup]="queryRecordFormGroup" nzLayout="vertical">
        <ng-container *ngIf="!isQueryExpanded">
          <div nz-row>
            <div nz-col nzSpan="17">
              <nz-form-item>
                <nz-form-label [nzRequired]="true" nzFor="name" class="nfl-form-label">Query Name</nz-form-label>
                <ng-container *ngIf="!queryId; else displayName">
                  <nz-form-control [nzErrorTip]="nameErrorTemplate">
                    <input
                      nz-input
                      formControlName="name"
                      nzSize="large"
                      id="name"
                      placeholder="Query Name"
                      appTrimFormInput
                      maxlength="100"
                    />
                  </nz-form-control>
                </ng-container>
                <ng-template #displayName>
                  <div class="w100">&nbsp;{{ nameFormControl.value }}</div>
                </ng-template>
              </nz-form-item>
              <ng-template #nameErrorTemplate let-control>
                <div *ngIf="control?.errors?.['required']">Please enter the name</div>
                <div *ngIf="control?.errors?.['minlength']">
                  Name must be at least
                  {{ control?.errors?.['minlength'].requiredLength }} characters long.
                </div>
                <div *ngIf="control?.errors?.['maxlength']">
                  Name cannot exceed
                  {{ control?.errors?.['maxlength'].requiredLength }} characters.
                </div>
                <div *ngIf="control?.errors?.['pattern']">
                  Name should not contain any special characters and should have at least one alphabet.
                </div>
              </ng-template>
            </div>

            <div nz-col nzSpan="6" nzOffset="1">
              <nz-form-item>
                <nz-form-label [nzRequired]="true" nzFor="type" class="nfl-form-label">Query Type</nz-form-label>
                <ng-container *ngIf="!queryId; else displayQueryType">
                  <nz-form-control nzErrorTip="Query type is required">
                    <nz-select nzPlaceHolder="Query Type" formControlName="type" id="type" nzSize="large">
                      <nz-option
                        [nzLabel]="type.name"
                        [nzValue]="type.value"
                        *ngFor="let type of queryTypes; index as i"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </ng-container>
                <ng-template #displayQueryType>
                  <div class="w100">&nbsp;{{ queryTypeFormControl.value }}</div>
                </ng-template>
              </nz-form-item>
            </div>
          </div>
          <!-- Description -->
          <div nz-row>
            <nz-form-item nz-col nzSpan="24">
              <nz-form-label [nzRequired]="true" nzFor="description" class="nfl-form-label"
                >Query Description</nz-form-label
              >
              <ng-container *ngIf="!queryId; else displayDescription">
                <nz-form-control [nzErrorTip]="descriptionErrorTemplate">
                  <textarea
                    appTrimFormInput
                    id="description"
                    nz-input
                    formControlName="description"
                    placeholder="Query Description"
                    [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                    maxlength="500"
                    [attr.disabled]="!queryId"
                  ></textarea>
                </nz-form-control>
              </ng-container>
              <ng-template #displayDescription>
                <div>&nbsp;{{ descriptionFormControl.value }}</div>
              </ng-template>
            </nz-form-item>
            <ng-template #descriptionErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Please enter the query description.</div>
              <div *ngIf="control?.errors?.['maxlength']">
                Description cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
              <div *ngIf="control?.errors?.['pattern']">Description should contain at least one alphabet</div>
            </ng-template>
          </div>
        </ng-container>
        <!-- Query input area-->
        <div nz-row>
          <nz-form-item>
            <nz-form-label *ngIf="!isQueryExpanded" [nzRequired]="true" nzFor="query" class="nfl-form-label"
              >Query Input Area</nz-form-label
            >
            <nz-form-control [nzErrorTip]="queryErrorTemplate">
              <div class="query-editor-wrapper" (keydown)="onKeyDown($event)">
                <app-monaco-editor
                  #queryEditor
                  formControlName="query"
                  appTrimFormInput
                  [expanded]="isQueryExpanded"
                ></app-monaco-editor>
                <button nz-button nzType="default" type="button" class="expand-btn" (click)="toggleQueryExpanded()">
                  <span nz-icon [nzType]="isQueryExpanded ? 'compress' : 'expand'" nzTheme="outline"></span>
                </button>
              </div>
            </nz-form-control>
          </nz-form-item>
          <ng-template #queryErrorTemplate let-control>
            <div *ngIf="control?.errors?.['required']">Please enter the query.</div>
            <div *ngIf="control?.errors?.['maxlength']">
              Query cannot exceed
              {{ control?.errors?.['maxlength'].requiredLength }} characters.
            </div>
            <div *ngIf="control?.errors?.['pattern']">Query should contain at least one alphabet</div>
          </ng-template>
        </div>
        <ng-container *ngIf="!isQueryExpanded">
          <!-- Button wrapper -->
          <div nz-row>
            <nz-form-item class="w100">
              <div class="button-row">
                <div>
                  <button
                    nz-button
                    nzSize="large"
                    nzType="primary"
                    [routerLink]="['/query']"
                    [hidden]="!queryId"
                    [disabled]="isLoading"
                  >
                    Create New Query
                  </button>
                </div>
                <div class="button-section">
                  <nz-space nzSize="middle">
                    <button
                      *nzSpaceItem
                      nz-button
                      nzSize="large"
                      nzType="text"
                      (click)="queryId ? handleUpdate() : handleSave()"
                      [nzLoading]="spinningState === 'save' || spinningState === 'update'"
                      [disabled]="queryRecordFormGroup.invalid || isLoading || checkValidationStatus"
                    >
                      {{ queryId ? 'Update' : 'Save' }}
                    </button>
                    <button
                      *nzSpaceItem
                      nz-button
                      nzSize="large"
                      nzType="default"
                      (click)="handleValidate()"
                      [nzLoading]="spinningState === 'validate'"
                      [disabled]="queryRecordFormGroup.invalid || isLoading || checkValidationStatus"
                    >
                      Validate
                    </button>
                    <ng-container *nzSpaceItem>
                      <button
                        *ngIf="!isSyntheticResultSuccess"
                        nz-button
                        nzSize="large"
                        nzType="default"
                        (click)="handleGenerateSyntheticResult()"
                        [nzLoading]="spinningState === 'generateSynthetic'"
                        [disabled]="
                          !queryId ||
                          queryTypeFormControl.value !== 'AGGREGATE' ||
                          isLoading ||
                          isSyntheticGenerationInProgress ||
                          !isValidationSuccess
                        "
                        nz-tooltip
                        [nzTooltipTitle]="
                          queryTypeFormControl.value !== 'AGGREGATE'
                            ? 'Only available for Aggregate queries'
                            : isSyntheticGenerationInProgress
                              ? 'Synthetic Result Generation in Progress'
                              : ''
                        "
                      >
                        Generate Synthetic Result
                      </button>
                    </ng-container>
                    <ng-container *nzSpaceItem>
                      <button
                        *ngIf="isSyntheticResultSuccess"
                        nz-button
                        nzSize="large"
                        nzType="default"
                        [disabled]="!queryId || queryTypeFormControl.value !== 'AGGREGATE' || !isValidationSuccess"
                        (click)="viewQueryRecord()"
                        nz-tooltip
                        [nzTooltipTitle]="
                          queryTypeFormControl.value !== 'AGGREGATE' ? 'Only available for Aggregate queries' : ''
                        "
                      >
                        View Synthetic Result
                      </button>
                    </ng-container>

                    <button
                      *nzSpaceItem
                      nz-button
                      nzSize="large"
                      nzType="primary"
                      (click)="submitQueryRecord()"
                      [nzLoading]="spinningState === 'submit'"
                      [disabled]="queryRecordFormGroup.invalid || isLoading || !isValidationSuccess"
                    >
                      Submit
                    </button>
                  </nz-space>
                </div>
              </div>
            </nz-form-item>
          </div>
          <!-- Query input area-->
          <nz-form-item>
            <nz-form-label class="nfl-form-label">Validation Logs</nz-form-label>
            <div class="validation-results">
              <p nz-typography *ngIf="!(validationLogs?.errors?.length || 0) && !validationException" nzType="success">
                {{ validationLogs?.message }}
              </p>
              <ng-container *ngIf="validationLogs?.warnings?.length || 0">
                <span nz-typography>Warnings</span>
                <div *ngFor="let warning of validationLogs?.warnings">
                  <p nz-typography nzType="warning">
                    {{ warning }}
                  </p>
                </div>
              </ng-container>

              <ng-container *ngIf="validationLogs?.errors?.length || 0">
                <span nz-typography>Errors</span>
                <div *ngFor="let error of validationLogs?.errors">
                  <p
                    nz-typography
                    nzType="danger"
                    (click)="onAthenaErrorClick(error)"
                    [ngStyle]="isClickableError(error) ? { cursor: 'pointer', 'text-decoration': 'underline' } : {}"
                  >
                    {{ error }}
                  </p>
                </div>
              </ng-container>

              <ng-container *ngIf="validationException">
                <span nz-typography>Exception</span>
                <div>
                  <p nz-typography nzType="danger">
                    {{ validationException }}
                  </p>
                </div>
              </ng-container>
            </div>
          </nz-form-item>
        </ng-container>
      </form>
    </nz-card>
  </div>
</div>

<ng-template #noDatabaseTemplate let-name>
  <div>
    <span nz-icon nzType="file-sync" nzTheme="outline"></span>
    <p>Please select the Datasource to get the Databases</p>
  </div>
</ng-template>

<div class="chat-overlay" [class.open]="isOpen">
  <div class="chat-header">
    <span>DCR AI</span>

    <div>
      <!-- <span (click)="insertQueryInQueryInputArea()">Insert into editor</span> -->
      <span nz-icon class="clear-chat-btn" nzType="delete" (click)="clearChat()"> </span>
      <span nz-icon nzType="close" class="close-btn" (click)="closePanel()"> </span>
    </div>
  </div>

  <div class="chat-content">
    <div *ngIf="messages.length === 0">
      <div>
        <h3>What do you want to build?</h3>
      </div>
      <div *ngFor="let sample of samples" class="sample-card" (click)="selectSample(sample)">
        {{ sample }}
      </div>
    </div>

    <div *ngFor="let msg of messages" class="message-wrapper">
      <!-- User -->

      <div *ngIf="msg.type === 'user'" class="user-row">
        <div class="user-message">
          {{ msg.text }}
        </div>

        <nz-avatar [nzText]="avatarLabel"></nz-avatar>
      </div>

      <!-- AI -->

      <div *ngIf="msg.type === 'bot'" class="bot-row">
        <div class="bot-title">✨ DCR AI</div>

        <div class="bot-message">
          {{ msg.text }}
        </div>

        <!--monaco editor starts-->
        <div class="code-container">
          <app-monaco-editor-bot
            [ngModel]="msg.sql"
            [readOnly]="true"
            (codeCopied)="onCodeCopied($event)"
          ></app-monaco-editor-bot>
        </div>
        <!--monaco editor ends-->
      </div>
    </div>
    <div *ngIf="isAiGeneratedQueryLoad">
      <div class="bot-title">✨ DCR AI</div>
      <label>{{ getThinkingMessage() }}</label>
    </div>
  </div>

  <div class="chat-footer">
    <textarea nz-input rows="3" [(ngModel)]="prompt" placeholder="{{ getPlaceHolder() }}" (keydown)="onKeyDown($event)">
    </textarea>

    <button
      nz-button
      nzType="primary"
      nzShape="circle"
      (click)="sendMessage()"
      [disabled]="prompt === '' || prompt?.trim() === ''"
    >
      <span nz-icon nzType="send"></span>
    </button>
  </div>
</div>
